import { render, staticRenderFns } from "./CustomRatingFilter.vue?vue&type=template&id=7c7584a0&"
import script from "./CustomRatingFilter.vue?vue&type=script&lang=js&"
export * from "./CustomRatingFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports